import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { useTheme } from '@mui/material';

const Viber: React.FC<IconProps> = ({ style, color, size, secondaryColor }) => {
  const theme = useTheme();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 512 512" style={style} width={size ?? '22'} height={size ?? '22'} data-testid="viber-icon">
      <rect width={512} height={512} fill={color ? secondaryColor || theme.palette.primary.main : '#665ca7'} rx="15%" />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={10}
        d="M269 186a30 30 0 0 1 31 31m-38-58a64 64 0 0 1 64 67m-73-93a97 97 0 0 1 99 104"
      />
      <path
        fillRule="evenodd"
        d="M95 232c0-91 17-147 161-147s161 56 161 147-17 147-161 147l-26-1-53 63c-4 4-8 1-8-3v-69c-6 0-31-12-38-19-22-23-36-40-36-118zm-30 0c0-126 55-177 191-177s191 51 191 177-55 177-191 177c-10 0-18 0-32-2l-38 43c-7 8-28 11-28-13v-42c-6 0-20-6-39-18-19-13-54-44-54-145zm223 42q10-13 24-4l36 27q8 10-7 28t-28 15q-53-12-102-60t-61-104q0-20 25-34 13-9 22 5l25 35q6 12-7 22c-39 15 51 112 73 70z"
      />
    </svg>
  );
};
export default Viber;
